<!--
 * @Descripttion: 
 * @version: 
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2020-05-29 11:27:44
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2020-12-17 16:17:42
-->
<template>
  <div id="app" class="wh100">  
    <transition name="fade"  mode="out-in">
    	<router-view class="pages" v-if="isRouterAlive"></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App',
  provide(){ // 父组件中通过provide来提供变量，再子组件中通过inject来注入变量
     return {
        reload: this.reload
     }
  },
  data(){
     return {
        isRouterAlive: true, //控制视图是否显示的变量
     }
  },
  methods: {
     reload () {
        this.isRouterAlive = false; //先关闭
        this.$nextTick(()=>{
           this.isRouterAlive = true; //再打开
        });
     }
  },
}
</script>

<style lang="less">

.fade-enter-active, .fade-leave-active {
    transition: all .3s ease;
}
.fade-enter, .fade-leave-active {
    opacity: 0;
}
input::-webkit-input-placeholder { /* WebKit, Blink, Edge */
    color:    #bbb;
}
input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
   color:    #bbb;
}
input::-moz-placeholder { /* Mozilla Firefox 19+ */
   color:    #bbb;
}
input:-ms-input-placeholder { /* Internet Explorer 10-11 */
   color:    #bbb;
}
textarea::-webkit-input-placeholder { /* WebKit, Blink, Edge */
    color:    #bbb;
}
textarea:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
   color:    #bbb;
}
textarea::-moz-placeholder { /* Mozilla Firefox 19+ */
   color:    #bbb;
}
textarea:-ms-input-placeholder { /* Internet Explorer 10-11 */
   color:    #bbb;
}
input:disabled, textarea:disabled {
    opacity: 1;
    -webkit-opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/App.vue